import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "nav-links nav-links-page" }, [
  /*#__PURE__*/_createElementVNode("div", {
    linkTo: "#about-section",
    class: "nav-link nav-link-section nav-link1"
  }, [
    /*#__PURE__*/_createElementVNode("h4", {
      class: "nav-link-txt",
      "data-text": "About"
    }),
    /*#__PURE__*/_createElementVNode("svg", {
      id: "Layer_2",
      "data-name": "Layer 2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 200 200"
    }, [
      /*#__PURE__*/_createElementVNode("circle", {
        class: "anim-elem1 cls-1",
        cx: "100.4",
        cy: "46.3",
        r: "42.3"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        class: "cls-1",
        d: "M54,196a39.7,39.7,0,0,1-22.4-6.6,7.1,7.1,0,0,1-1.4-1c-7.7-5.7-11.8-15.2-12.4-24.5a103.8,103.8,0,0,1,.5-19.3A87.2,87.2,0,0,1,25,120.5c3.1-7.2,7.1-14.3,13.3-19.3s12-7.1,18.8-6.9c8.5.2,13.5,4.9,21.3,7.7a70.4,70.4,0,0,0,21.3,3.7h.6a70.4,70.4,0,0,0,21.3-3.7c7.8-2.8,12.8-7.5,21.3-7.7,6.8-.2,13.4,2.7,18.8,6.9s10.2,12.1,13.3,19.3a87.2,87.2,0,0,1,6.7,24.1,103.8,103.8,0,0,1,.5,19.3c-.6,9.3-4.7,18.8-12.4,24.5a7.1,7.1,0,0,1-1.4,1A39.7,39.7,0,0,1,146,196Z"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    linkTo: "#dev-projects",
    class: "nav-link nav-link-section nav-link2"
  }, [
    /*#__PURE__*/_createElementVNode("h4", {
      class: "nav-link-txt",
      "data-text": "Web-Dev"
    }),
    /*#__PURE__*/_createElementVNode("svg", {
      id: "Layer_2",
      "data-name": "Layer 2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 200 200"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        class: "anim-elem1 cls-1",
        d: "M5,99.6a8.7,8.7,0,0,1,1.1-4.1L38.7,39.1a8.1,8.1,0,0,1,11.1-3h0a8.1,8.1,0,0,1,3,11L23.2,98.5a2.2,2.2,0,0,0,0,2.2l29.6,51.2a8.2,8.2,0,0,1-3,11.1h0a8.2,8.2,0,0,1-11.1-2.9L6.1,103.6A8.6,8.6,0,0,1,5,99.6Z"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        class: "anim-elem2 cls-1",
        d: "M195,99.6a8.7,8.7,0,0,0-1.1-4.1L161.3,39.1a8.1,8.1,0,0,0-11.1-3h0a8.1,8.1,0,0,0-3,11l29.6,51.3a2.2,2.2,0,0,1,0,2.2l-29.6,51.2a8.2,8.2,0,0,0,3,11.1h0a8.2,8.2,0,0,0,11.1-2.9l32.6-56.5A8.6,8.6,0,0,0,195,99.6Z"
      }),
      /*#__PURE__*/_createElementVNode("rect", {
        class: "cls-2",
        x: "32.5",
        y: "92.2",
        width: "134.8",
        height: "15.6",
        rx: "7.8",
        transform: "translate(-22.6 170.6) rotate(-75)"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    linkTo: "#design-projects",
    class: "nav-link nav-link-section nav-link3"
  }, [
    /*#__PURE__*/_createElementVNode("h4", {
      class: "nav-link-txt",
      "data-text": "Design"
    }),
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 200 200"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        class: "cls-1",
        d: "M144.4,125.4a33.4,33.4,0,0,0,5.2,1.4c7,1.4,19.6,2.7,30.4-3.5a28.7,28.7,0,0,0,7-5.5c5.4-5.6,8-13,8.8-20.7,1.1-10.5-2-21.1-6.5-30.7C175.5,37.1,146.2,14.9,114,11.2a109.5,109.5,0,0,0-46.2,4.6A101,101,0,0,0,43.4,27.9a92.4,92.4,0,0,0-26.2,27c-19.1,30-17.1,68,3.9,96.4a93.2,93.2,0,0,0,16.3,16.9c14.2,11.4,31.9,18.1,49.9,20.4a116.9,116.9,0,0,0,19.6.8c4.5-.3,9.8-.8,13.2-4.3s3.7-8.5.4-12-4.9-3.6-7.5-5.2c-9-5.5-16.2-15.7-13.2-26.6a23.3,23.3,0,0,1,10.4-12.7c3.2-1.9,9.8-4.5,19.3-4.9A45.3,45.3,0,0,1,144.4,125.4Z"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        class: "cls-1",
        cx: "48.6",
        cy: "78.4",
        r: "15.7"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        class: "cls-1",
        cx: "99.9",
        cy: "49",
        r: "15.7"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        class: "cls-1",
        cx: "151.6",
        cy: "77",
        r: "15.7"
      }),
      /*#__PURE__*/_createElementVNode("circle", {
        class: "cls-1",
        cx: "56.1",
        cy: "136.9",
        r: "15.7"
      }),
      /*#__PURE__*/_createElementVNode("g", { class: "anim-elem1" }, [
        /*#__PURE__*/_createElementVNode("path", {
          class: "cls-2",
          d: "M138.4,119.4l53.3,53.3c4.1,4.1,4.4,10.4.7,14.1h0c-3.6,3.7-10,3.3-14.1-.7l-53.2-53.3"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          class: "cls-3",
          d: "M120.1,92.9c6.6,3.1,10.4,5.9,13.7,11.1s7.1,17.1,0,24.1-18.6,3.4-24.1,0-8.1-7-11.2-13.7c-2.2-4.6-7.9-23.6-9.8-29.9a1.1,1.1,0,0,1,.7-1.4h.7C96.4,84.9,115.4,90.7,120.1,92.9Z"
        })
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    linkTo: "#contact-form",
    class: "nav-link nav-link-section nav-link4"
  }, [
    /*#__PURE__*/_createElementVNode("h4", {
      class: "nav-link-txt",
      "data-text": "Contact"
    }),
    /*#__PURE__*/_createElementVNode("svg", {
      id: "Layer_2",
      "data-name": "Layer 2",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 200 200"
    }, [
      /*#__PURE__*/_createElementVNode("rect", {
        class: "cls-1",
        x: "5",
        y: "24.8",
        width: "189.9",
        height: "150.5",
        rx: "18.9"
      }),
      /*#__PURE__*/_createElementVNode("path", {
        class: "anim-elem1 cls-1",
        d: "M25.1,45.1l50.6,56.4a33.1,33.1,0,0,0,49.3,0l50.2-56.1"
      }),
      /*#__PURE__*/_createElementVNode("line", {
        class: "cls-1",
        x1: "143.5",
        y1: "120",
        x2: "175",
        y2: "154.6"
      }),
      /*#__PURE__*/_createElementVNode("line", {
        class: "cls-1",
        x1: "25",
        y1: "155",
        x2: "57.2",
        y2: "119.7"
      })
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"nav-links nav-links-social\"><a href=\"https://github.com/newhorizonweb\" target=\"_blank\" class=\"nav-link nav-link5\" aria-label=\"GitHub Link\"><h4 class=\"nav-link-txt\" data-text=\"Github\"></h4><svg id=\"Layer_2\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\"><path class=\"anim-elem1 cls-1\" d=\"M82.6,144.3c-21.1-2.4-43.2-10.5-43.2-46.9a36,36,0,0,1,9.8-25.5,33.5,33.5,0,0,1,.9-25.1s7.9-2.6,26.1,9.7a89.1,89.1,0,0,1,47.5,0c18.1-12.3,26.1-9.7,26.1-9.7a34,34,0,0,1,.9,25.1,36.8,36.8,0,0,1,9.8,25.5c0,36.4-22.1,44.4-43.3,46.8\"></path><path class=\"cls-1\" d=\"M117.2,144.2a22.7,22.7,0,0,1,6.4,17.7v26c0,3.2,1.7,5.5,6.5,4.5a95.1,95.1,0,1,0-60.1,0c4.7.9,6.5-2,6.5-4.4V171.9c-26.5,5.7-32-12.8-32-12.8a25.4,25.4,0,0,0-10.7-14c-8.7-5.9.6-5.8.6-5.8a19.4,19.4,0,0,1,14.5,9.8c8.5,14.5,22.1,10.3,27.7,7.9a20.5,20.5,0,0,1,6-12.7\"></path></svg></a><a href=\"https://www.linkedin.com/in/wojciech-bocho/\" target=\"_blank\" class=\"nav-link nav-link6\" aria-label=\"LinkedIn Link\"><h4 class=\"nav-link-txt\" data-text=\"LinkedIn\"></h4><svg id=\"Layer_2\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 200 200\"><circle class=\"anim-elem1 cls-1\" cx=\"27.8\" cy=\"27.8\" r=\"22.7\"></circle><rect class=\"anim-elem2 cls-1\" x=\"7.7\" y=\"68.6\" width=\"40.6\" height=\"126.25\" rx=\"2\"></rect><path class=\"cls-1\" d=\"M195,116.1c0-7.9,0-14.2-3.2-23.6A42.5,42.5,0,0,0,171,68.6c-2-1-20.7-10.5-39.9-1-12.7,6.4-18.5,16.8-19.9,24.6h0V70.6a2,2,0,0,0-2-2H74.6a2,2,0,0,0-2,2V192.9a2,2,0,0,0,2,2h34.6c2-1.2,2-1.9,2-2V127.8s-.5-18.2,10.4-25.1a24.2,24.2,0,0,1,24.8-.3c8.5,5.2,9.9,13.7,9.9,27.8v62.6a2,2,0,0,0,2,2H193c2-1.1,2-1.9,2-2V116.1\"></path></svg></a></div>", 1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
}